import { pushToDataLayer } from '@/js/analytics/analytics.methods.js';

const links = [...document.querySelectorAll('.js-content-picker-link')];

function bindEventListener(link) {
  link.addEventListener('click', () => {
    pushToDataLayer({
      event: 'content_picker_click',
      link_text: link.textContent,
      link_url: link.href,
      featured_content: link.dataset.type,
      content_surface_method: link.dataset.method,
    });
  });
}

function init() {
  if (!links.length) {
    return;
  }

  links.forEach((link) => bindEventListener(link));
}

export default init;
